'use strict';

const BasePresenter = require('./base');
const moment = require('moment');
const { ticketDateTimeFormat, tbdDateFormat, tbdTimeFormat } = require('../constants');

class InfoPresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    const quantitySelected = this.model.get('selectedQuantity');
    const quantity = quantitySelected ? quantitySelected.getPartySize() : 1;

    const selectedSection = this.model.get('selectedSection');
    const optionSelected = selectedSection != null;
    const displayPrice = selectedSection || this.model.get('sections').getCheapest();
    const displayDiscount = selectedSection || this.model.get('sections').getMostDiscounted();
    const price = this.formatMoney(displayPrice.getPrice() * quantity, displayPrice.getPriceCurrencyCode());
    const savings = this.formatMoney(displayPrice.getSavings() * quantity, displayPrice.getPriceCurrencyCode());
    const value = this.formatMoney(displayPrice.getValue() * quantity, displayPrice.getValueCurrencyCode());
    const discount = displayDiscount.getDiscount();
    const discountEnabled = this.model.discountEnabled();

    const isReadyToBook = this.model.isReadyToBook();
    const useConsistentPriceBadging = this.model.get('useConsistentPriceBadging');

    const selectedDate = this.model.get('selectedDate');
    const selectedTime = this.model.get('selectedTime');
    const ticketDateTime = this.formatDateTime(selectedDate, selectedTime);

    return {
      discount,
      discountEnabled,
      isReadyToBook,
      optionSelected,
      price,
      quantity,
      quantitySelected,
      savings,
      ticketDateTime,
      useConsistentPriceBadging,
      value,
    };
  }

  formatMoney(amountCents, currencyCode) {
    const formattedCurrency = I18n.toCurrency(amountCents / 100, { currencyCode });
    const trailingZerosRegex = /[,\.]00(?!\d)/;
    return formattedCurrency.replace(trailingZerosRegex, '');
  }

  formatDateTime(date, time) {
    if (!(date && time)) {
      return '';
    }
    if (date.toString() === 'TBD' || time.toString() === 'TBD') {
      return this.formatDateTimeTBD(date.toString(), time.toString());
    }
    const dateTimeString = date && time ? `${date.toString()}T${time.toString()}` : '';
    const formattedDateTime = dateTimeString !== '' ? moment(dateTimeString).format(ticketDateTimeFormat) : '';
    return formattedDateTime;
  }

  formatDateTimeTBD(dateString, timeString) {
    if (dateString === 'TBD' && timeString !== 'TBD') {
      // We just want a formatted time here, but moment requires a date for instantiation
      const currentDateString = moment()
        .format()
        .substring(0, 11);
      const currentDateWithProvidedTime = `${currentDateString}${timeString}`;
      const formattedTimeString = moment(currentDateWithProvidedTime).format(tbdDateFormat);
      return `Date TBD, ${formattedTimeString}`;
    } else if (timeString === 'TBD' && dateString !== 'TBD') {
      const formattedDateString = moment(dateString).format(tbdTimeFormat);
      return `${formattedDateString} Time TBD,`;
    }

    return 'Date & Time TBD,';
  }
}

module.exports = InfoPresenter;
